var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 374,
    viewBox: "0 0 460 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8182 373.546C43.9766 335.853 23.3467 285.833 23.3467 230.984C23.3467 113.809 117.498 18.6772 233.467 18.6772C349.436 18.6772 443.586 113.809 443.586 230.984C443.586 285.834 422.956 335.853 389.115 373.546H77.8182Z",
    fill: "#F2F9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7433 373.546C18.2075 334.296 0 284.89 0 231.242C0 103.615 103.043 0 229.964 0C356.886 0 459.929 103.615 459.929 231.242C459.929 284.89 441.721 334.296 411.186 373.546H408.898C439.719 334.426 458.131 284.979 458.131 231.242C458.131 104.614 355.893 1.80805 229.964 1.80805C104.036 1.80805 1.79803 104.614 1.79803 231.242C1.79803 284.979 20.2104 334.426 51.0311 373.546H48.7433Z",
    fill: "#F2F9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBackground);
export default __webpack_public_path__ + "static/media/image-background.3ec6fc69e2007f8bb6ed9cee8041c0a3.svg";
export { ForwardRef as ReactComponent };